import { Injectable } from '@angular/core';
import {
  ICellChangeResponse,
  IQuotationBlock, IQuotationSection, IQuotationTraveller
} from "../../../../../libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { ITableRow } from "../../../../shared/services/table-data/ITable";

@Injectable({
  providedIn: 'root'
})
export class RefreshTableDataService {

  public refreshQuotationRows(cellChangeResponse: ICellChangeResponse, tableData: ITableRow[]): void {
    //Refresh quotation retail (global margin/markup, profit, total retail)
    tableData[0].totalRetail = cellChangeResponse.quotation.retail;
    tableData[0].totalVat = cellChangeResponse.quotation.vat;
    tableData[0].totalRetailIncludingVat = cellChangeResponse.quotation.retailIncludingVat;
    //Refresh quotation retail (adjustment)
    tableData[1].totalRetail = cellChangeResponse.quotation.retail;
    tableData[1].totalVat = cellChangeResponse.quotation.vat;
    tableData[1].totalRetailIncludingVat = cellChangeResponse.quotation.retailIncludingVat;

  }

  public refreshBlockRow(cellChangeResponse: ICellChangeResponse, tableData: ITableRow[]): void {

    const rowIndex: number = tableData.findIndex((row: ITableRow): boolean => row.block && row.block.id === cellChangeResponse.blockId);
    const blockUpdated: IQuotationBlock = cellChangeResponse.quotation.sections
        .reduce((blocks: IQuotationBlock[], section: IQuotationSection): IQuotationBlock[] => {
          if (section.blocks) {
            return [...blocks, ...section.blocks];
          }
          return blocks;
        }, [])
        .find((block: IQuotationBlock): boolean => block.id === cellChangeResponse.blockId);
    tableData[rowIndex].block.retail = blockUpdated.retail;
    tableData[rowIndex].block.vat = blockUpdated.vat;
    tableData[rowIndex].block.retailIncludingVat = blockUpdated.retailIncludingVat;
    tableData[rowIndex].block.travellerPrices = blockUpdated.travellerPrices;

  }

  public refreshAllBlockRows(cellChangeResponse: ICellChangeResponse, tableData: ITableRow[]): void {
    const blocksUpdated: IQuotationBlock[] = cellChangeResponse.quotation.sections
        .reduce((blocks: IQuotationBlock[], section: IQuotationSection): IQuotationBlock[] => {
          if (section.blocks) {
            return [...blocks, ...section.blocks];
          }
          return blocks;
        }, []);
    tableData
        .map((tableRow: ITableRow): ITableRow => {
          if (tableRow.block) {
            const blockUpdated: IQuotationBlock = blocksUpdated
                .find((block: IQuotationBlock): boolean => block.id === tableRow.block.id);
            tableRow.block.retail = blockUpdated.retail;
            tableRow.block.vat = blockUpdated.vat;
            tableRow.block.retailIncludingVat = blockUpdated.retailIncludingVat;
            tableRow.block.travellerPrices = blockUpdated.travellerPrices;
          }
          return tableRow;
        });
  }

  public refreshTravellersOnTotalRow(cellChangeResponse: ICellChangeResponse, tableData: ITableRow[], isIncludedPage: boolean): void {
    if (!isIncludedPage) {
      // there is no traveller total row on options page
      return;
    }

    //refresh quotation traveller (total retail)
    tableData[0].travellers
        .forEach((referenceTraveller: IQuotationTraveller): void => {
          const newTraveller: IQuotationTraveller = cellChangeResponse.quotation.travellers
              .find((traveller: IQuotationTraveller): boolean => traveller.id === referenceTraveller.id);
          referenceTraveller.retail = newTraveller.retail;
          referenceTraveller.vat = newTraveller.vat;
          referenceTraveller.retailIncludingVat = newTraveller.retailIncludingVat;
        });
    //refresh quotation traveller (adjustment)
    tableData[1].travellers = tableData[0].travellers;

  }

  public refreshTravellerTotalRowsById(cellChangeResponse: ICellChangeResponse, tableData: ITableRow[]): void {

    const updatedTraveller: IQuotationTraveller = cellChangeResponse.quotation.travellers
        .find((traveller: IQuotationTraveller): boolean => traveller.id === cellChangeResponse.travellerId);
    //refresh quotation traveller (total retail)
    this.refreshTravellerRetailInRowById(0, updatedTraveller, cellChangeResponse.travellerId, tableData);
    this.refreshTravellerRetailInRowById(1, updatedTraveller, cellChangeResponse.travellerId, tableData);

  }

  public refreshTravellerRetailInRowById(rowNumber: number, updatedTraveller: IQuotationTraveller, travellerId: number, tableData: ITableRow[]): void {
    const referenceTraveller: IQuotationTraveller = tableData[rowNumber].travellers
        .find((traveller: IQuotationTraveller): boolean => traveller.id === travellerId);
    referenceTraveller.retail = updatedTraveller.retail;
    referenceTraveller.vat = updatedTraveller.vat;
    referenceTraveller.retailIncludingVat = updatedTraveller.retailIncludingVat;
  }
}
